import { modulePage } from "../../core/Application";
import { Api, LOADER_FULLPAGE } from "../../core/components/Api";
import { helper } from "../../core/Helper";

export class Recaptcha extends Api implements modulePage {
    readonly name: string = "Recaptcha";

    private buttonId = "captcha-btn";
    private submitBtn = document.getElementById(this.buttonId) as HTMLButtonElement;

    private addEvents = () => {
        if (this.submitBtn) {
            helper.loadScript(`https://www.google.com/recaptcha/api.js?render=${window.appConfig.captcha}`).then(() => {
                const form = this.submitBtn.closest('form') as HTMLFormElement;

                this.submitBtn.addEventListener("click", (e) => {
                    this.showLoader({ loader: LOADER_FULLPAGE });
                    e.preventDefault();
                    if (form.checkValidity()) {
                        window.grecaptcha.ready(async () => {
                            const token = await window.grecaptcha.execute(window.appConfig.captcha, {
                                action: 'submit'
                            });

                            const cInput = document.createElement("input");
                            cInput.setAttribute("type", "hidden");
                            cInput.setAttribute("name", "captcha");
                            cInput.setAttribute("value", token);

                            form.appendChild(cInput);
                            form.submit();
                        });
                    } else {
                        form.reportValidity();
                        this.hideLoader();
                    }
                });
            });
        }
    }

    init(): void {
        this.addEvents();
    }
}